import 'regenerator-runtime/runtime';

import App from './App.js';
import React from 'react';
import { createRoot } from 'react-dom/client';
import ErrorBoundary from './ErrorBoundary.js';

import './main.css';

/** config */
import config from './config/index.js';

/** store */
import store from './store/index.js';

/** Contexts */
import { AppContext } from './context/AppContext.js';
import { APIContext, API } from './context/APIContext.js';
export { store, AppContext, APIContext, API };

window.addEventListener('load', function() {
  main();
});

function main() {
  /** create app and render */
  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(
    <ErrorBoundary>
      <App config={config} />
    </ErrorBoundary>
  );
}
